import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import AppDirectory from '../components/AppDirectory';
import Footer from '../components/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-charcoal text-white font-display">
      <Navbar />
      <main>
        <Hero />
        <AppDirectory />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
